import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";
import { trackEvent } from "@/lib/analytics";

export const WhatsAppFloat = () => {
  const { content } = useContent();
  const wa = content?.settings?.whatsapp;
  if (!wa) return null;
  return (
    <motion.a
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      href={`https://wa.me/${wa}?text=${encodeURIComponent("Hello Royal Skin Cosmetic Clinic, I would like to book a consultation.")}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-float-button"
      onClick={() => trackEvent("whatsapp_click")}
      className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-transform duration-500 hover:scale-110"
    >
      <MessageCircle className="h-6 w-6" />
    </motion.a>
  );
};
